import React, { FC } from "react";

import { OutlinedInput, makeStyles } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import { TextFieldProps } from "@material-ui/core/TextField";

import { Colors } from "../../styles";

const colors = {
    default: {
        borderColorDefault: Colors.anthracite25,
        borderColorFocused: Colors.blueBright,
        borderColorHover: Colors.mellowYellow,
        borderWidth: "1px",
    },
    error: {
        borderColorDefault: Colors.radiantRed,
        borderColorFocused: Colors.radiantRed,
        borderColorHover: Colors.radiantRed,
        borderWidth: "2px",
    },
    warn: {
        borderColorDefault: Colors.mellowYellow,
        borderColorFocused: Colors.mellowYellow,
        borderColorHover: Colors.mellowYellow,
        borderWidth: "2px",
    },
};

type Props = TextFieldProps & {
    state?: keyof typeof colors;
    style?: React.CSSProperties;
    endAdornment?: React.ReactNode;
};

export const useStyles = makeStyles({
    labledTextfieldLabel: {
        marginLeft: 20,
        height: 28,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    labledTextfieldLabelError: {
        marginLeft: 20,
        height: 28,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.radiantRed,
    },
});

export const useOutlinedInputStyles = (props: {
    state: keyof typeof colors;
}): (() => Record<string, string>) =>
    makeStyles({
        root: {
            marginTop: 7,
            borderRadius: 28,
            height: 56,
            background: Colors.white,

            fontSize: 22,
            fontWeight: 300,
            fontStretch: "normal",
            fontStyle: "normal",
            fontFamily: "innogyWEB",
            lineHeight: 1.27,
            letterSpacing: "normal",
            color: Colors.anthracite,

            "& $notchedOutline": {
                borderColor: colors[props.state].borderColorDefault,
                borderWidth: colors[props.state].borderWidth,
            },
            "&:hover $notchedOutline": {
                borderColor: colors[props.state].borderColorHover,
                borderWidth: colors[props.state].borderWidth,
            },
            "&$focused $notchedOutline": {
                borderColor: colors[props.state].borderColorFocused,
                borderWidth: colors[props.state].borderWidth,
            },
            "&$focused": {
                //backgroundColor: Colors.eggshell,
            },
        },

        focused: {},
        notchedOutline: {},

        input: {
            padding: 20,
        },
    });

export const LabledTextField: FC<Props> = (props: Props) => {
    const {
        label,
        value,
        onBlur,
        onChange,
        onFocus,
        onClick,
        name,
        error,
        style,
        placeholder,
        endAdornment,
        inputProps,
    } = props;
    const classes = useStyles();
    const outlinedInputClasses = useOutlinedInputStyles({ state: error ? "error" : "default" })();

    return (
        <Grid item>
            <InputLabel
                className={error ? classes.labledTextfieldLabelError : classes.labledTextfieldLabel}
            >
                {label}
            </InputLabel>
            <div style={{ position: "relative" }}>
                <OutlinedInput
                    labelWidth={0}
                    classes={outlinedInputClasses}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    onClick={onClick}
                    onFocus={onFocus}
                    endAdornment={endAdornment}
                    name={name}
                    style={style}
                    placeholder={placeholder}
                    inputProps={inputProps}
                />
            </div>
        </Grid>
    );
};
